import { useOutletContext } from 'react-router-dom';
import IntroduceFoundationalValue from './introduceFoundationalValue';
import IntroduceSectionTitle from './IntroduceSectionTitle';
import IntroduceStatement from './introduceStatement';
import IntroduceVision from './introduceVision';

function IntroduceFoundationVision() {
  const { getMenuName } = useOutletContext() || {};

  return (
    <div className="introduce-combined-content">
      <section
        className="introduce-combined-section"
        style={{ '--introduce-delay': '0ms' }}
      >
        <IntroduceSectionTitle>
          {getMenuName?.('thong-diep', 'message') || ''}
        </IntroduceSectionTitle>
        <IntroduceStatement />
      </section>

      <section
        className="introduce-combined-section"
        style={{ '--introduce-delay': '90ms' }}
      >
        <IntroduceSectionTitle>
          {getMenuName?.(
            'logo-gia-tri-nen-tang',
            'logo-foundational-values',
          ) || ''}
        </IntroduceSectionTitle>
        <IntroduceFoundationalValue showTitle={false} />
      </section>

      <section
        className="introduce-combined-section"
        style={{ '--introduce-delay': '180ms' }}
      >
        <IntroduceSectionTitle>
          {getMenuName?.(
            'tam-nhin-su-menh-gia-tri-cot-loi',
            'vision-mission-values-core',
          ) || ''}
        </IntroduceSectionTitle>
        <IntroduceVision showTitle={false} />
      </section>
    </div>
  );
}

export default IntroduceFoundationVision;
